import DesktopConversationList from "@/components/messages/DesktopConversationList";
import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { useMediaQuery } from "@/hooks/useMediaQuery";
import { ConversationResponse } from "@/generated-api";
import MobileConversation from "@/components/messages/MobileConversation";
import DesktopConversation from "@/components/messages/DesktopConversation";
import MobileConversationList from "@/components/messages/MobileConversationList";
import { useTranslation } from "@/hooks/useTranslation";
import { useStandaloneMode } from "@/hooks/useStandaloneMode";

export default function MessagesPage() {
  const isDesktop = useMediaQuery("(min-width: 768px)");
  const params = useParams();
  const navigate = useNavigate();
  const isStandalone = useStandaloneMode();
  const t = useTranslation();

  const profileId = isDesktop
    ? params.profileId || sessionStorage.getItem("chatProfileId") || undefined
    : params.profileId || undefined;

  const [selectedConversation, setSelectedConversation] =
    useState<ConversationResponse | null>(null);

  useEffect(() => {
    if (isDesktop) {
      window.scrollTo(0, 0);
    }
  }, [isDesktop]);

  function handleDeleteConversation(counterpartyId: string) {
    if (selectedConversation?.counterparty.counterparty_id === counterpartyId) {
      setSelectedConversation(null);
    }
    if (sessionStorage.getItem("chatProfileId") === counterpartyId) {
      sessionStorage.removeItem("chatProfileId");
    }
  }

  if (isDesktop) {
    return (
      <div className="flex flex-row w-full h-fit max-w-5xl items-center mt-4 mb-16 border-t border-zinc-600 rounded-2xl border mx-auto">
        <div className={`w-[40%] border-r border-zinc-600`}>
          <DesktopConversationList
            onSelectConversation={(v) => {
              setSelectedConversation(v);
              sessionStorage.setItem(
                "chatProfileId",
                v.counterparty.counterparty_id
              );
            }}
            onDeleteConversation={handleDeleteConversation}
            selectedConversation={selectedConversation}
            selectedCounterpartyId={profileId}
          />
        </div>
        <div className={`w-[60%]`}>
          {selectedConversation ? (
            <DesktopConversation
              counterpartyId={selectedConversation.counterparty.counterparty_id}
              isSelected={true}
            />
          ) : profileId ? (
            <DesktopConversation counterpartyId={profileId} isSelected={true} />
          ) : (
            <div className="flex text-gray-500 h-full items-center justify-center">
              {t.MESSAGES.LABELS.SELECT_TO_START}
            </div>
          )}
        </div>
      </div>
    );
  }

  if (profileId) {
    return <MobileConversation counterpartyId={profileId} />;
  } else {
    return (
      <div
        className={`flex flex-row w-full max-w-5xl mx-auto items-center -mt-4 ${
          isStandalone ? "pb-14" : "pb-10"
        }`}
      >
        <MobileConversationList
          onSelectConversation={(v) => {
            setSelectedConversation(v);
            navigate("/messages/" + v.counterparty.counterparty_id);
          }}
          onDeleteConversation={handleDeleteConversation}
        />
      </div>
    );
  }
}
